import { ReactNode, useState } from 'react'

import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useSubmitForm } from '../FormComponent/useSubmitForm'
import { DataTableV2SubmissionAction } from '../DataTableV2/types'
import { CardClickTarget } from './CardClickTarget'
import { CardData } from './types'

export function CardSubmitAction({
  action,
  data,
  children,
}: {
  action: DataTableV2SubmissionAction
  data: CardData
  children: ReactNode
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(
    action.handlerId,
    [...tileFilterSelections, { actionId: action.id }],
    action.id,
    action.requireConfirmation ? { onSuccess: () => setIsOpen(false) } : undefined
  )

  if (!action.isVisible) return <>{children}</>

  const submit = () => {
    submitForm(data as unknown as Record<string, unknown>)
  }

  const trigger = (
    <CardClickTarget
      disabled={action.isDisabled || isSubmitting}
      onClick={action.requireConfirmation ? undefined : submit}
    >
      {children}
    </CardClickTarget>
  )

  if (!action.requireConfirmation) return trigger

  return (
    <ConfirmDialog
      trigger={trigger}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title={action.label}
      description={action.confirmationMessage}
      onConfirm={submit}
      closeOnConfirm={false}
      isSubmitting={isSubmitting}
    />
  )
}
